import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const FALLBACK_FLAG = String.fromCodePoint(0x1f3f3, 0xfe0f);

const parseSize = (value, fallback) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const toFlagEmoji = (countryCode) => {
  if (!countryCode || typeof countryCode !== 'string' || countryCode.length < 2) {
    return FALLBACK_FLAG;
  }

  const [first, second] = countryCode.trim().toUpperCase();
  const isValidLetter = (char) => char >= 'A' && char <= 'Z';
  if (!isValidLetter(first) || !isValidLetter(second)) {
    return FALLBACK_FLAG;
  }

  const base = 0x1f1e6;
  return String.fromCodePoint(
    base + first.charCodeAt(0) - 65,
    base + second.charCodeAt(0) - 65
  );
};

const CountryFlag = React.forwardRef(function CountryFlag(
  { className, countryCode, height, title, width },
  ref
) {
  const computedSize = Math.max(
    12,
    parseSize(height, parseSize(width, 20))
  );

  return (
    <Flag
      aria-label={title || countryCode}
      className={className}
      ref={ref}
      role="img"
      title={title || countryCode}
      $size={computedSize}
    >
      {toFlagEmoji(countryCode)}
    </Flag>
  );
});

CountryFlag.propTypes = {
  className: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

CountryFlag.defaultProps = {
  height: 20,
  title: ''
};

export default CountryFlag;

const Flag = styled.span`
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: ${({ $size }) => `${$size * 0.8}px`};
  height: ${({ $size }) => `${$size}px`};
  justify-content: center;
  line-height: 1;
  overflow: hidden;
  width: ${({ $size }) => `${$size}px`};
`;
